import { render, staticRenderFns } from "./GoalLink.vue?vue&type=template&id=0d25faaa"
import script from "./GoalLink.vue?vue&type=script&lang=js"
export * from "./GoalLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports